/**
 *
 * Usage:
 * data-sw-auto-submit
 *    Automatically submits a form on a change event.
 *
 * data-sw-auto-submit-single-submit=<bool>
 *    When you need to disable this and other forms from submitting while
 *    the form is submitting. Useful for HTML for submits, we need a more
 *    robust solution for AJAX once we come across that use case.
 *
 * data-sw-auto-submit-click
 *    Automatically submits on a click.
 *
 */
var $ = require('js/sw-jquery/sw-jquery');

var AUTO_SUBMIT_SELECTOR = '[data-sw-auto-submit]';
var AUTO_SUBMIT_CLICK_SELECTOR = '[data-sw-auto-submit-click]';

$(function() {
  var $body = $('body');
  $body.on('change', AUTO_SUBMIT_SELECTOR, function() {
    var $el = $(this);
    var enforceSingleSubmit = $el.data('swAutoSubmitSingleSubmit');

    $el.closest('form').trigger('submit');

    // When we want to make sure a user doesn't keep interacting with forms after a form has been submitted
    // to maintain a consistent and reliable experience.
    if (enforceSingleSubmit) {
      $body.off('change', AUTO_SUBMIT_SELECTOR);
    }
  });

  $body.on('click', AUTO_SUBMIT_CLICK_SELECTOR, function() {
    var $el = $(this);
    $el.closest('form').trigger('submit');
  });
});
